import {
  all,
  fork,
  call,
  put,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";
import { push } from "react-router-redux";
import NetworkHandler from "../net/NetworkHandler";
import StorageHandler from "../storage/StorageHandler";
import * as ACTIONS from "../containers/constants";
import { error, success } from "../components/Alert/actions";
import {
  updateAllCryodex,
  updateInvite,
  updateIsolatedCryodex,
} from "../containers/Home/actions";
import {
  updateEditCryodexProfile,
  savingComplete,
} from "../containers/EditCryodex/actions";
import { createCipher } from "crypto";
import { startNotification } from "../components/Notification/actions";
const storageHandler = new StorageHandler();
function* getAllCryodexes(action) {
  const Network = new NetworkHandler();
  try {
    const response = yield Network.requestGetAllCryodexes();
    if (!(response instanceof Error)) {
	  yield put(updateAllCryodex(response[0]));
      localStorage.setItem("allFriends", JSON.stringify(response));
    } else {
      yield put(
        error({
          message: `Unable to get cryodexes groups. ${response}`,
        })
      );
    }
  } catch (errorMsg) {
    yield put(
      error({
        message: `Unable to load cryodexes, please try again.${errorMsg}`,
      })
    );
  }
}
function* getSelectedCryodex(action) {
  const Network = new NetworkHandler();
  try {
    const response = yield Network.requestIsolatedCryodex(action.payload);
    if (!(response instanceof Error)) {
      localStorage.setItem("userDetails", JSON.stringify(response));
      yield put(updateIsolatedCryodex(response));
    } else {
      yield put(
        error({
          message: "Unable to create user",
        })
      );
    }
  } catch (errorMsg) {
    yield put(
      error({
        message: `Unable to load user, please try again.${errorMsg}`,
      })
    );
  }
}
function* checkFriendship(action) {
  const Network = new NetworkHandler();
  try {
    const response = yield Network.requestCheckFriendship(action.payload);
    if (!(response instanceof Error)) {
      yield put(updateIsolatedCryodex(response));
    } else {
      yield put(
        error({
          message: "Unable to create user",
        })
      );
    }
  } catch (errorMsg) {
    yield put(
      error({
        message: `Unable to load user, please try again.${errorMsg}`,
      })
    );
  }
}
function* sendInviteRequest(action) {
  const Network = new NetworkHandler();
  try {
    var inviteObject = {};
    inviteObject.to = action.payload.to;
    inviteObject.from = action.payload.from;
    inviteObject.status = action.payload.status;
    const response = yield Network.requestInviteCryodex(inviteObject);
    if (!(response instanceof Error)) {
      if (response.status === true) {
        alert("Processing completed successfully.");
        yield put(updateInvite(response));
        if (!action.payload.status.includes("reject"))
          yield put(startNotification());
      } else {
        alert("Processing failed. Contact admin.");
      }
    } else {
      yield put(
        error({
          message: `Unable to invite cryodex. ${response}`,
        })
      );
    }
  } catch (errorMsg) {
    yield put(
      error({
        message: `Unable to invite cryodex, please try again`,
      })
    );
  }
}
function* updateCryodexInfodexLink(action) {
  var cryodexInfodexLink = {};
  cryodexInfodexLink.Infodex_ID = action.payload;
  cryodexInfodexLink.Cryodex_ID = storageHandler.getID();
  const networkHandler = new NetworkHandler();
  try {
    const response = yield networkHandler.requestCryodexInfodexLink(
      cryodexInfodexLink
    );
    if (!(response instanceof Error)) {
      yield put(updateEditCryodexProfile(response));
    } else {
      yield put(
        error({
          message: `Unable to get selected cryodex profile. ${response}`,
        })
      );
    }
  } catch (errorMsg) {
    yield put(
      error({
        message: `Unable to get selected cryodex profile`,
      })
    );
  }
}
function* updateUser(action) {
  try {
    var ageDifMs = Date.now() - new Date(action.payload.age);
    var ageDate = new Date(ageDifMs); // miliseconds from epoch
    var age = Math.abs(ageDate.getUTCFullYear() - 1970);
    var userObject = {};
    userObject.Username = action.payload.username;
    userObject.ImageSource = action.payload.profileImage;
    userObject.Age = age;
    userObject.DateBirth = action.payload.age;
    userObject.Mobile_Number = action.payload.mobileNumber;
    userObject.Country_ID = action.payload.countryOptionId;
    userObject.City_ID = action.payload.cityOptionId;
    userObject.Email = action.payload.email;
    userObject.Password = action.payload.password;
    userObject.Cryodex_ID = action.payload.cryodex_id;
    try {
      const networkHandler = new NetworkHandler();
      const response = yield networkHandler.requestUpdateUser(userObject);
      if (response) {
        alert("Profile updated. Refresh to see changes.");
        window.location.reload();
      } else {
        alert(response);
      }
    } catch (errorMsg) {
      alert(errorMsg);
    }
  } catch (errorMsg) {
    alert(errorMsg);
    yield put(error({}));
  }
}
function* updateCryodexProfile(action) {
  const networkHandler = new NetworkHandler();
  try {
    if (!action) {
      return;
    }
    const response = yield networkHandler.requestUpdateUser(action);
    if (!(response instanceof Error)) {
      yield put(savingComplete());
      if (response.status) {
        //window.location.reload();
      }
    } else {
      yield put(
        error({
          message: `Unable to edit selected cryodex profile. ${response}`,
        })
      );
    }
  } catch (errorMsg) {
    yield put({
      message: `Unable to update cryodex profile`,
    });
  }
}
export default function* usersSagas() {
  yield takeLatest(ACTIONS.CRYODEX_CRYODEX_ALL_GET, getAllCryodexes);
  yield takeLatest(ACTIONS.CRYODEC_GET_ISOLATED_CRYODEX, getSelectedCryodex);
  yield takeLatest(ACTIONS.CRYODEX_GET_INVITE, sendInviteRequest);
  yield takeLatest(ACTIONS.UPDATE_USER_PROFILE, updateUser);
  yield takeLatest(
    ACTIONS.CRYODEX_CRYODEX_INFODEX_LINK_UPDATE,
    updateCryodexInfodexLink
  );
  yield takeLatest(ACTIONS.CRYODEX_CHECK_FRIENDSHIP, checkFriendship);
}
